import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { ExamTypeResponse } from "../../models/dtos";

export const examTypesApi = createApi({
  reducerPath: 'examTypesApi',
  baseQuery: baseAuthQuery('ExamTypes'),
  tagTypes: ['ExamType'],
  endpoints: (builder) => ({
    getExamTypes: builder.query<ApiResponse<ExamTypeResponse[]>, void>({
      query: () => "",
      providesTags: ['ExamType'],
    }),
    getExamTypeById: builder.query<ApiResponse<ExamTypeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['ExamType'],
    }),
    updateExamType: builder.mutation<ApiResponse<ExamTypeResponse>, Partial<ExamTypeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['ExamType'],
    }),
    deleteExamType: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['ExamType'],
    }),
  }),
});
